export type AudioFile = {
  MediaID: string;
  LocationID: string;
  MediaType: string;
  FileName: string;
  ContentType: string;
  FilePath: string;
};

export const audioFiles: AudioFile[] = [
  {
    MediaID: 'd32a6fa1-bab0-437c-9e5d-96c2771f1764',
    LocationID: '96bb3af1-75bb-441d-ae03-73f010aa7fdf',
    MediaType: 'PHONE_SYSTEM',
    FileName: 'en-US-Standard-F',
    ContentType: 'audio/wav',
    FilePath:
      'https://api.weaveconnect.com/support/v1/phonemedia/download/96bb3af1-75bb-441d-ae03-73f010aa7fdf/d32a6fa1-bab0-437c-9e5d-96c2771f1764',
  },
  {
    MediaID: 'c008c154-18f8-4f54-9653-9952be008a98',
    LocationID: '96bb3af1-75bb-441d-ae03-73f010aa7fdf',
    MediaType: 'PHONE_SYSTEM',
    FileName: 'en-US-Standard-J',
    ContentType: 'audio/wav',
    FilePath:
      'https://api.weaveconnect.com/support/v1/phonemedia/download/96bb3af1-75bb-441d-ae03-73f010aa7fdf/c008c154-18f8-4f54-9653-9952be008a98',
  },
  {
    MediaID: '11bfd0a7-4652-43c1-a0f1-2420d9fb38c1',
    LocationID: '96bb3af1-75bb-441d-ae03-73f010aa7fdf',
    MediaType: 'PHONE_SYSTEM',
    FileName: 'es-US-News-F',
    ContentType: 'audio/wav',
    FilePath:
      'https://api.weaveconnect.com/support/v1/phonemedia/download/96bb3af1-75bb-441d-ae03-73f010aa7fdf/11bfd0a7-4652-43c1-a0f1-2420d9fb38c1',
  },
  {
    MediaID: '5a18f6cf-2421-4fa2-a42f-a9db4139abbb',
    LocationID: '96bb3af1-75bb-441d-ae03-73f010aa7fdf',
    MediaType: 'PHONE_SYSTEM',
    FileName: 'es-US-Polyglot-1',
    ContentType: 'audio/wav',
    FilePath:
      'https://api.weaveconnect.com/support/v1/phonemedia/download/96bb3af1-75bb-441d-ae03-73f010aa7fdf/5a18f6cf-2421-4fa2-a42f-a9db4139abbb',
  },
];
